export default function IndustriesHeader() {
  return (
    <section
      className="relative pt-32 pb-20 bg-cover bg-center"
      style={{
        backgroundImage:
          "url('https://public.readdy.ai/ai/img_res/7f6291752bd556b06a446e4db76d1fd6.jpg')",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-[#0F172A]/85 via-[#0F172A]/75 to-[#0F172A]/85" />
      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <span className="inline-block bg-amber-500 text-slate-900 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-6">
          Industries We Serve
        </span>
        <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
          Built for Service Businesses{' '}
          <span className="text-amber-400">That Depend on Speed</span>
        </h1>
        <p className="text-slate-300 text-xl leading-relaxed max-w-2xl mx-auto">
          We understand your workflows, your leads, and your revenue cycle.
        </p>
      </div>
    </section>
  );
}
